import { ApdmImportStage } from '@euler/functions/apdm/import/importState';

const kLabels: Record<ApdmImportStage, string> = {
  [ApdmImportStage.Reading]: '正在读取文件',
  [ApdmImportStage.Recognizing]: '正在识别各列内容',
  [ApdmImportStage.Organizing]: '正在整理服务记录',
};

export function importStageLabel(stage: ApdmImportStage): string {
  return kLabels[stage];
}
